export abstract class AbstractPaymentStoreRequest {
  public order_id: string;
  public charge_amount: number;

  protected constructor(orderId: string, chargeAmount?: number) {
    this.order_id = orderId;
    this.charge_amount = chargeAmount;
  }
}
